import React from 'react';
import '../styles/pricing-results.css';

const PricingResults = ({ costs, formData, onGenerateProposal, onConsultationRequest }) => {
  if (!costs) return null;
  
  return (
    <div className="pricing-results">
      <h3>Project Estimate</h3>
      
      <div className="project-summary">
        <p><strong>Project Type:</strong> {formatProjectType(formData.projectType)}</p>
        <p><strong>Complexity:</strong> {costs.complexity.charAt(0).toUpperCase() + costs.complexity.slice(1)}</p>
      </div>
      
      <div className="cost-breakdown">
        <h4>Development Costs</h4>
        <div className="cost-item">
          <span>Discovery & Design:</span>
          <span>${costs.breakdown.development.discoveryDesign.min.toLocaleString()} - ${costs.breakdown.development.discoveryDesign.max.toLocaleString()}</span>
        </div>
        <div className="cost-item">
          <span>Implementation:</span>
          <span>${costs.breakdown.development.implementation.min.toLocaleString()} - ${costs.breakdown.development.implementation.max.toLocaleString()}</span>
        </div>
        <div className="cost-item">
          <span>Testing & Deployment:</span>
          <span>${costs.breakdown.development.testingDeployment.min.toLocaleString()} - ${costs.breakdown.development.testingDeployment.max.toLocaleString()}</span>
        </div>
        <div className="cost-item total-cost">
          <span>Total Development:</span>
          <span>${costs.totalDevRange.min.toLocaleString()} - ${costs.totalDevRange.max.toLocaleString()}</span>
        </div>
      </div>
      
      <div className="cost-breakdown">
        <h4>Monthly Costs</h4>
        <div className="cost-item">
          <span>AWS Infrastructure:</span>
          <span>${costs.breakdown.monthly.infrastructure.min.toLocaleString()} - ${costs.breakdown.monthly.infrastructure.max.toLocaleString()}</span>
        </div>
        <div className="cost-item">
          <span>Maintenance & Support:</span>
          <span>${costs.breakdown.monthly.maintenance.min.toLocaleString()} - ${costs.breakdown.monthly.maintenance.max.toLocaleString()}</span>
        </div>
        <div className="cost-item">
          <span>Model Updates & Training:</span>
          <span>${costs.breakdown.monthly.modelUpdates.min.toLocaleString()} - ${costs.breakdown.monthly.modelUpdates.max.toLocaleString()}</span>
        </div>
        <div className="cost-item total-cost">
          <span>Total Monthly:</span>
          <span>${costs.totalMonthlyRange.min.toLocaleString()} - ${costs.totalMonthlyRange.max.toLocaleString()}</span>
        </div>
      </div>
      
      {formData.useSelfServiceWizard && (
        <div className="discount-note">
          <p>This estimate includes a 50% discount through our Self Service Build Wizard.</p>
        </div>
      )}
      
      <div className="results-actions">
        <button className="proposal-button" onClick={onGenerateProposal}>
          Generate Detailed Proposal
        </button>
        <button className="consultation-button" onClick={onConsultationRequest}>
          Request Free Consultation
        </button>
      </div>
    </div>
  );
};

// Helper function to format project type for display
const formatProjectType = (type) => {
  switch (type) {
    case 'inventory':
      return 'Inventory Management System';
    case 'document_ai':
      return 'Document AI Solution';
    case 'computer_vision':
      return 'Computer Vision Solution';
    case 'genai_agent':
      return 'GenAI Agent';
    case 'chatbot':
      return 'Chatbot';
    case 'analytics':
      return 'Data Analytics Solution';
    case 'recommendation':
      return 'Recommendation System';
    default:
      return 'Custom AI Solution';
  }
};

export default PricingResults;